import React, { useEffect, useState } from "react";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { Card, CardHeader, Stack } from "@mui/material";
import MaterialTypography from "../../../components/MaterialTypography";
import MaterialButton from "../../../components/MaterialButton";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";
import MaterialDataGrid from "../../../components/MaterialDataGrid";
import _ from "lodash";
import request from "graphql-request";
import BASEURL from "../../../pages/Utils/Baseurl";
import { allProductCategories } from "./productCategoryData";
import PageLoading from "../../../components/Loading/PageLoading";
import Swal from "sweetalert2";
import RoleAccess from "../../function/RoleAccess";
const ProductCategory = () => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  useEffect(() => {
    fetchdata();
  }, []);
  const ProductCategoryListTable = {
    columns: [
      {
        headerName: "S.No",
        field: "sno",
        name: "S.NO",
        flex: 0,
        disableColumnMenu: true,
        editable: false,
      },
      {
        headerName: "Category Code",
        field: "categoryCode",
        name: "categoryCode",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },

      {
        headerName: "Category Name",
        field: "categoryName",
        name: "categoryName",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
      },
      {
        headerName: "Category Description",
        field: "categoryDescription",
        name: "categoryDescription",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },
      {
        headerName: "Create By",
        field: "createdBy",
        name: "createdBy",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },

      {
        headerName: "Create Date",
        field: "createdAt",
        name: "createdAt",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },

      {
        headerName: "Action",
        field: "Action",
        name: "Action",
        flex: 0,
        disableColumnMenu: true,
        editable: false,
      },
    ],
    rows: data.map((v, i) => ({
      sno: i + 1,
      id: v.id,
      categoryCode: v?.categoryCode,
      categoryName: _.capitalize(v?.categoryName),
      categoryDescription: _.capitalize(v?.categoryDescription),
      createdBy:v?.user?.employeeName,
      createdAt: v?.createdAt?.slice(0, 10),
      Action: (
        <div
          style={{
            display: "flex",

            marginTop: "10px",
            alignItems: "center",
          }}
        >
          <RoleAccess
            modelName="Product Category Screen"
            component="ViewProductCategory"
          >
            <VisibilityIcon
              fontSize="small"
              className="actionIcon"
              onClick={() =>
                navigate(`/product-category/view-product-category`, {
                  state: { type: "view", data: v },
                })
              }
            />
          </RoleAccess>
          <RoleAccess
            modelName="Product Category Screen"
            component="UpdateProductCategory"
          >
            <EditIcon
              fontSize="small"
              className="actionIcon"
              onClick={() =>
                navigate(`/product-category/edit-product-category`, {
                  state: { type: "edit", data: v },
                })
              }
            />
          </RoleAccess>

          {/* <DeleteIcon
                style={{ color: "GrayText", fontSize: "20px" }}
                onClick={() => handleDelte(v?.id)}
              /> */}
        </div>
      ),
    })),
  };
  const fetchdata = () => {
    setIsLoading(true);

    request(BASEURL, allProductCategories)
      .then((res) => {
        const success = res?.allProductCategories?.success;
        const message = res?.allProductCategories?.message;
        if (success) {
          setData(res?.allProductCategories?.data);
        } else {
          Swal.fire({
            position: "top",
            icon: "error",
            title: message,
            showConfirmButton: true,
          });
          setData([]);
        }
      })
      .catch((err) => {
        const message =
          err?.response?.errors?.[0]?.message ||
          err?.message ||
          "Something went wrong";
        Swal.fire({
          position: "top",
          icon: "error",
          title: message,
          showConfirmButton: true,
        });
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <DashboardLayout>
      <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="column" spacing={0}>
                <MaterialTypography variant="h5" fontWeight="medium">
                  Product Category List
                </MaterialTypography>
              </Stack>
              <RoleAccess
                modelName="Product Category Screen"
                component="CreateProductCategory"
              >
                <MaterialButton
                  variant="gradient"
                  color="dark"
                  size="small"
                  startIcon={<AddIcon />}
                  onClick={() =>
                    navigate("/product-category/add-product-category", {
                      state: { type: "add" },
                    })
                  }
                >
                  Product Category
                </MaterialButton>
              </RoleAccess>
            </Stack>
          }
        />
        {!isLoading && (
          <MaterialDataGrid
            // customHeight={550}
            rows={ProductCategoryListTable?.rows}
            columns={ProductCategoryListTable?.columns}
            // checkboxSelection={false}
            isSelectable={false}
            // onRowClick={onCustomerListClick}
            //   loading={pageState.loading}
            localeText={{
              noRowsLabel: (
                <Stack
                  direction="column"
                  alignItems="center"
                  justifyContent="center"
                  spacing={1}
                >
                  <MaterialTypography
                    variant="body2"
                    fontWeight="medium"
                    color="text"
                  >
                    No Product Category found
                  </MaterialTypography>
                  <MaterialTypography variant="caption" color="text">
                    You have not yet add any Product Category details. Click on
                    the "Add Product Category" button to start adding Product
                    Category details.
                  </MaterialTypography>
                </Stack>
              ),
            }}
          />
        )}

        {isLoading && <PageLoading />}
      </Card>
    </DashboardLayout>
  );
};

export default ProductCategory;
